/**
 * Wraps a callback to yield to the main thread before execution.
 *
 * @deprecated Use `yieldToMain` instead for simpler, more flexible code.
 *
 * @example
 * ```ts
 * // Before (deprecated)
 * const handleClick = yieldCallback(() => doExpensiveWork());
 *
 * // After (recommended)
 * const handleClick = async () => {
 *   await yieldToMain();
 *   doExpensiveWork();
 * };
 * ```
 */
export const yieldCallback =
  <TEventHandler extends (...args: any[]) => void>(
    handler: TEventHandler,
    delay: number = 0,
  ) =>
  (...args: Parameters<TEventHandler>) => {
    if (typeof handler === 'function') {
      requestAnimationFrame(() => setTimeout(() => handler(...args), delay));
    }
  };
